module.exports = __webpack_public_path__ + "img/kkam_thumbnail.3ceac292.jpg";